// Correlaciona POST/PUT/DELETE async (que retornam 202) com o broadcast
// ActionCable de confirmação. As stores criam uma promise pendente identificada
// por (resource, eventType, id); o handleRealtimeEvent resolve/rejeita quando
// o broadcast correspondente chega. Permite que o frontend use
// `toast.promise(storeAction)` mostrando loading → success/error real do backend.

const pendingOps = new Map();

const DEFAULT_TIMEOUT_MS = 30000;

const buildKey = (resource, eventType, id) =>
  `${resource}:${eventType}:${id == null ? '*' : id}`;

/**
 * Cria uma promise que resolve/rejeita quando `resolvePendingOp` for chamado
 * com a mesma (resource, eventType, id), ou rejeita por timeout.
 */
export const createPendingOp = (
  resource,
  eventType,
  id,
  { timeoutMs = DEFAULT_TIMEOUT_MS } = {}
) => {
  const key = buildKey(resource, eventType, id);

  // Se já existe pendente pro mesmo key (ex: 2 cliques duplos), rejeita o
  // anterior pra não vazar promise.
  const existing = pendingOps.get(key);
  if (existing) {
    existing.reject(new Error('Operação substituída por nova chamada'));
  }

  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      if (pendingOps.get(key)?.timer === timer) {
        pendingOps.delete(key);
        reject(
          new Error(
            'Tempo esgotado aguardando confirmação do servidor (30s). A operação pode ainda ser concluída em background.'
          )
        );
      }
    }, timeoutMs);

    pendingOps.set(key, { resolve, reject, timer });
  });
};

/**
 * Resolve a promise pendente correspondente. No-op se não houver pendente.
 */
export const resolvePendingOp = (resource, eventType, id, status, error) => {
  const key = buildKey(resource, eventType, id);
  const pending = pendingOps.get(key);
  if (!pending) return;

  clearTimeout(pending.timer);
  pendingOps.delete(key);

  if (status === 'success') {
    pending.resolve();
  } else {
    pending.reject(new Error(error || 'Operação falhou no servidor'));
  }
};
